import React, { useState } from 'react'
import SearchFavoriteGame from './SearchFavoriteGame'
import GameData from './Data.json'

function ProfileEdit() {
  return (
    <div className='container'>
            <div className='row'>
                <h1>This is a profile page for: {localStorage.user}</h1>
            </div>
            <div className='row'>
                <div className='col'>
                    <h1>Favorite Game: </h1>
                </div>
                <div className='col'>
                <SearchFavoriteGame  placeholder="Enter name of Game" data={GameData}/>
                </div>
               
            </div>
            <div className='row'>
                    <button>Confirm</button>
                </div>
        </div>
  )
}

export default ProfileEdit